import PosthogService from '~/services/posthog/PosthogService';
import { UserProfession } from '~/enums/UserProfession';

// Event-specific interface (co-located)
export interface IPermPostJobWorkDetailsSubmittedPayload {
  postingId: string;
  professionType: UserProfession;
}

/**
 * Fires when user submits work details in the post job flow
 * Event: dental_portal:perm_post_job:work_details_submitted
 */
export function firePermPostJobWorkDetailsSubmitted(
  payload: IPermPostJobWorkDetailsSubmittedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:work_details_submitted', {
    posting_id: payload.postingId,
    profession_type: payload.professionType,
  });
}